import React from 'react';

import {IntlShape} from 'react-intl';
import {BaselinePDFClientType} from './BaselinePDFTypes';
import {TextAuxiliary, TextMain, ViewColumn, ViewRow} from './layout/PDFLayout';

type BaselinePDFMetaProps = {
	client?: BaselinePDFClientType;
	creatorName: string;
	date: string;
	intl: IntlShape;
};

const BaselinePDFMeta = ({client, creatorName, date, intl: {formatMessage}}: BaselinePDFMetaProps): JSX.Element => {
	return (
		<ViewRow>
			{client ? (
				<ViewColumn style={{marginRight: '48px'}}>
					<TextAuxiliary>{formatMessage({id: 'baseline.pdf.prepared_for'})}</TextAuxiliary>
					<TextMain>{client.name}</TextMain>
					{client.street ? <TextMain>{client.street}</TextMain> : null}
					{client.city && client.zip ? (
						<TextMain>
							{client.city}, {client.zip}
						</TextMain>
					) : null}
					{client.vat ? (
						<TextMain>
							{formatMessage({id: 'company_details.vat_label'})}: {client.vat}
						</TextMain>
					) : null}
				</ViewColumn>
			) : null}
			<ViewColumn style={{marginRight: '48px'}}>
				<TextAuxiliary>{formatMessage({id: 'baseline.pdf.prepared_by'})}</TextAuxiliary>
				<TextMain>{creatorName}</TextMain>
			</ViewColumn>
			<ViewColumn style={{marginRight: '48px'}}>
				<TextAuxiliary>{formatMessage({id: 'common.date'})}</TextAuxiliary>
				<TextMain>{date}</TextMain>
			</ViewColumn>
		</ViewRow>
	);
};

export default BaselinePDFMeta;
